import config from 'crm/config'

const profileApi = `${config.apiHost}/oem-profile`

export default {
    // 素材增删改查
    list: {
        url: `${profileApi}/api/media`,
        type: 'GET',
    },
    // 添加素材
    create: {
        url: `${profileApi}/api/media`,
        type: 'POST',
    },
    // 批量添加素材（上传文件）
    batchCreate: {
        url: `${profileApi}/api/media/batch_add`,
        type: 'POST',
    },
    update: {
        url: `${profileApi}/api/media/{id}`,
        type: 'PUT',
    },
    remove: {
        url: `${profileApi}/api/media/{id}`,
        type: 'DELETE',
    },
    // 批量删除素材
    batchRemove: {
        url: `${profileApi}/api/media/batch_delete`,
        type: 'DELETE',
    },
    // 分组增删改查
    groups: {
        url: `${profileApi}/api/media/categories/tree`,
        type: 'GET',
    },
    createGroup: {
        url: `${profileApi}/api/media/categories`,
        type: 'POST',
    },
    updateGroup: {
        url: `${profileApi}/api/media/categories/{id}`,
        type: 'PUT',
    },
    removeGroup: {
        url: `${profileApi}/api/media/categories/{id}`,
        type: 'DELETE',
    },
    // 批量分组
    batchGroup: {
        url: `${profileApi}/api/media/batch_classify`,
        type: 'POST',
    },
    // 批量设置可见范围
    batchShare: {
        url: `${profileApi}/api/media/visible_type`,
        type: 'PUT',
    },
    // 获取网页链接信息
    webPageInfo: {
        url: `${profileApi}/api/media/articles/extract`,
        type: 'POST',
    },
    // 获取小程序
    mpa: {
        url: `${profileApi}/api/mpa`,
        type: 'GET',
    },
}
